import { COUNTER_ACTION } from "../../utils/constants";

export const updateCounter = (counterPayload) => ({
  type: COUNTER_ACTION,
  payload: counterPayload,
});
